import { render, staticRenderFns } from "./InformarPlacaVeiculoFormCarga.vue?vue&type=template&id=179292f3&"
import script from "./InformarPlacaVeiculoFormCarga.vue?vue&type=script&lang=js&"
export * from "./InformarPlacaVeiculoFormCarga.vue?vue&type=script&lang=js&"
import style0 from "./InformarPlacaVeiculoFormCarga.vue?vue&type=style&index=0&id=179292f3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports